import { render, staticRenderFns } from "./SexSelector.vue?vue&type=template&id=6fefbc5e&scoped=true&"
import script from "./SexSelector.vue?vue&type=script&lang=js&"
export * from "./SexSelector.vue?vue&type=script&lang=js&"
import style0 from "./SexSelector.vue?vue&type=style&index=0&id=6fefbc5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fefbc5e",
  null
  
)

export default component.exports